<template>
  <div>
    <div
      id="navPanel"
      class="sidePanel"
      @click="handlePanelClick"
    >
      <div class="panelContents">
        <div class="productLogo" />
        <div
          id="navPanelPinner"
          @click="handlePinClick"
        />
        <div class="navMenu">
          <div v-if="rRepos.length">
            <div class="menuSectionTitle notActive">
              R Repos
            </div>
            <ReposList :repos="rRepos" />
          </div>
          <div v-if="biocRepos.length">
            <div class="menuSectionTitle notActive">
              Bioconductor Repos
            </div>
            <ReposList :repos="biocRepos" />
          </div>
          <div v-if="pythonRepos.length">
            <div class="menuSectionTitle notActive">
              Python Repos
            </div>
            <ReposList :repos="pythonRepos" />
          </div>
          <div class="menuSectionTitle notActive">
            Info
          </div>
          <div class="menu">
            <div class="menuItems">
              <router-link
                v-if="metricsEnabled"
                :to="{ name: 'stats'}"
                class="menuItem stats"
              >
                Usage Stats
              </router-link>
              <a
                class="menuItem adminGuide"
                :href="docURL"
                target="_blank"
              >Admin Guide</a>
              <a
                class="menuItem apiDocs"
                :href="apiDocURL"
                target="_blank"
              >Server API Guide</a>
              <div
                class="menuItem legalDoc"
                @click="handleTermsClick"
              >
                Terms and Conditions
              </div>
            </div>
          </div>
          <div
            v-if="currentRepoDescription"
            class="comment"
          >
            {{ currentRepoDescription }}
          </div>
        </div>
      </div>
    </div>
    <TermsDialog
      v-if="showTermsDialog"
      @closeDialog="closeTermsDialog"
    />
  </div>
</template>

<script>

import { mapState, mapGetters } from 'vuex'
import * as types from '../store/mutation-types'
import TermsDialog from './dialogs/TermsDialog'
import { setLocalState, PIN_NAV_PANEL } from '../utils/local-storage'
import { serverPath } from '../api/http-common'
import ReposList from './ReposList'
import { REPO_TYPE_R, REPO_TYPE_PYTHON, REPO_TYPE_BIOCONDUCTOR } from '../constants/repo-types'

export default {
  name: 'StandardNavPanel',
  components: {
    TermsDialog,
    ReposList,
  },
  data: function () {
    return {
      showTermsDialog: false,
    }
  },
  computed: {
    ...mapState({
      allRepos: state => state.repos.allRepos,
      currentRepoId: state => state.repos.currentRepoId,
      menuItems: state => state.appFrame.menuItems,
      currentNav: state => state.appFrame.currentNav,
      pinNavPanel: state => state.appFrame.pinNavPanel,
      metricsEnabled: state => state.status.metricsEnabled,
      latestUpdate: state => state.status.latestUpdate,
    }),
    ...mapGetters([
      'currentRepo',
    ]),
    currentRepoDescription: function () {
      if (this.currentRepo) {
        return this.currentRepo.description
      }
      return ''
    },
    docURL: function () {
      return `${serverPath()}__docs__/admin`
    },
    apiDocURL: function () {
      return `${serverPath()}__api__/swagger/index.html`
    },
    rRepos: function () {
      return this.allRepos.filter(repo => repo.type === REPO_TYPE_R)
    },
    biocRepos: function () {
      return this.allRepos.filter(repo => repo.type === REPO_TYPE_BIOCONDUCTOR)
    },
    pythonRepos: function () {
      return this.allRepos.filter(repo => repo.type === REPO_TYPE_PYTHON)
    },
  },
  methods: {
    handlePanelClick: function () {
      this.$store.commit(types.SET_SHOW_NAV_PANEL, false)
    },
    handlePinClick: function () {
      const newPin = !this.pinNavPanel
      this.$store.commit(types.SET_PIN_NAV_PANEL, newPin)
      setLocalState(PIN_NAV_PANEL, newPin)
    },
    handleTermsClick: function () {
      this.showTermsDialog = true
    },
    closeTermsDialog: function () {
      this.showTermsDialog = false
    },
  },
}
</script>
